document.addEventListener('DOMContentLoaded', () => {

  const modalOverlay = document.getElementById('notify-modal-overlay');
  const submitBtn = document.getElementById('notify-submit');

  if (!modalOverlay || !submitBtn) return;

  const closeBtn = document.querySelector('.notify-close-btn');
  const sizeInput = document.getElementById('notify-size');
  const emailInput = document.querySelector('.notify-email');
  const body = document.body;

  const mobilePopup = document.querySelector('.size-popup');
  const mobileSelect = document.querySelector('.bihend-selecet-la');
  const headerPositionLa = document.querySelector('.header-la');
  const announcementBarPositionLa = document.querySelector('.announcement_bar-la');

  function unlockSizePopupScroll() {
    if (window.ArmosSizePopupScroll) {
      window.ArmosSizePopupScroll.unlock();
      return;
    }

    body.classList.remove('no-scroll-body');
  }

  function isValidEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  function validateInputs() {
    const sizeFilled = sizeInput.value.trim() !== '';
    const email = emailInput.value.trim();
    const emailValid = isValidEmail(email);

    if (sizeFilled && emailValid) {
      submitBtn.disabled = false;
      submitBtn.classList.add('active');
    } else {
      submitBtn.disabled = true;
      submitBtn.classList.remove('active');
    }
  }

  function closeModal() {
    modalOverlay.classList.remove('notify-modal-open');
    body.classList.remove('bodyOverflow');

    sizeInput.value = '';
    emailInput.value = '';

    submitBtn.disabled = true;
    submitBtn.classList.remove('active');
    submitBtn.innerText = 'Submit';
  }

  document.addEventListener('click', (e) => {

    const notifyBtn = e.target.closest('.notify-me-btn-la');
    if (!notifyBtn) return;

    if (window.innerWidth <= 989) {
      mobilePopup?.classList.remove('size-popup-active');
      mobileSelect?.classList.remove('bihend-selecet-active-la');
      headerPositionLa?.classList.remove('header-collapsible-overflow-la');
      announcementBarPositionLa?.classList.remove('announcement-collapsible-overflow-la');
      unlockSizePopupScroll();
    }

    const size = notifyBtn.dataset.size || '';
    const sku = notifyBtn.dataset.sku || '';

    sizeInput.value = size;
    emailInput.value = '';

    submitBtn.dataset.sku = sku;

    validateInputs();

    modalOverlay.classList.add('notify-modal-open');
    body.classList.add('bodyOverflow');
  });

  closeBtn?.addEventListener('click', closeModal);

  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) closeModal();
  });

  // ✅ EMAIL INPUT VALIDATION + RED BORDER
  emailInput.addEventListener('input', () => {
    const email = emailInput.value.trim();

    if (email === '' || isValidEmail(email)) {
      emailInput.classList.remove('input-error');
    } else {
      emailInput.classList.add('input-error');
    }

    validateInputs();
  });

  submitBtn.addEventListener('click', (e) => {
    e.preventDefault();

    const customerEmail = emailInput.value.trim();
    const productSize = sizeInput.value.trim();
    const productName =
      document.querySelector('.notify-title')?.innerText || '';
    const productSku = submitBtn.dataset.sku || '';

    submitBtn.innerText = 'Sending...';
    submitBtn.disabled = true;

    const data = {
      service_id: 'service_aggiqu7',
      template_id: 'template_f9j0409',
      user_id: 'JsS4exj13YCE4181B',
      template_params: {
        UserInfo: customerEmail,
        ContactFormName: productName,
        ProductSKU: productSku,
        ProductSize: productSize,
      },
    };

    fetch('https://api.emailjs.com/api/v1.0/email/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then(() => {
        submitBtn.innerText = 'Sent ✓';
        setTimeout(closeModal, 1500);
      })
      .catch((error) => {
        console.error('EmailJS Error:', error);
        alert('Email sending failed');
        submitBtn.innerText = 'Submit';
        submitBtn.disabled = false;
      });
  });

});
